import { Component, OnInit, EventEmitter, Output, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { AutenticacaoInfo, AutenticacaoService, AutenticacaoStatus } from 'src/app/autenticacao/autenticacao.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { Dialog } from '@syncfusion/ej2-angular-popups';
import { TokenDto } from 'src/app/autenticacao/modelos/token-dto';
import jwt_decode from 'jwt-decode';
import { AutenticacaoDto, TipoAutenticacao } from 'src/app/autenticacao/modelos/autenticacao-dto';
import { PacienteService } from 'src/app/servicos/paciente.service';
import { PacienteDto } from 'src/app/dtos/pacientes/paciente-dto';
import { AgendamentoDto } from 'src/app/dtos/agendamentos/agendamento-dto';
import { ProfissionalProfissaoTipo } from 'src/app/autenticacao/modelos/usuario';
import { UsuarioService } from 'src/app/autenticacao/usuario.service';
import { DashboardService } from 'src/app/servicos/dashboard.service';
import { AcompanhamentoMeusService } from 'src/app/acompanhamento-meus/acompanhamento-meus.service';
import { AtendimentoMeusService } from 'src/app/atendimento-meus/atendimento-meus.service';

@Component({
  selector: 'app-navegacao',
  templateUrl: './navegacao.component.html',
  styleUrls: ['./navegacao.component.less']
})
export class NavegacaoComponent implements OnInit, OnDestroy {
  pacienteAtual: PacienteDto | null = null;

  agendamentosHoje: number = 0;
  acompanhamentosAtivos: number = 0;

  @ViewChild('modalSair', { static: true })
  modalSair!: Dialog;

  @Output()
  onViewInit: EventEmitter<any> = new EventEmitter();
  
  AutenticacaoStatus = AutenticacaoStatus;

  ainfo: AutenticacaoInfo | null = null;

  dashSubs: Subscription | null = null;

  constructor(private fb: FormBuilder, 
    private router: Router,
    private autenticacaoService: AutenticacaoService,
    private pacienteService: PacienteService,
    private dashService: DashboardService,
    private usuarioServico: UsuarioService,
    private meusAcompanhamentos: AcompanhamentoMeusService,
    private meusAgendamentos: AtendimentoMeusService,
    private activatedRoute: ActivatedRoute) { 
  }

  ngOnDestroy(): void {
    this.dashSubs?.unsubscribe();
  }

  ngOnInit() {
    this.dashSubs = this.dashService.assuntoDash.subscribe(() => {
      this.atualizarAgendamentos();
      this.atualizarAcompanhamentos();
    });

    this.pacienteService.pacienteAtual$.subscribe((paciente) => {
      this.pacienteAtual = paciente;
    });

    this.autenticacaoService.autenticacaoStatus.subscribe((autenticacao: AutenticacaoDto) => {
      this.ainfo = null;

      if(autenticacao.tipoAutenticacao === TipoAutenticacao.Validado) {
        const decoded = jwt_decode<AutenticacaoInfo>(autenticacao.token.token);

        this.ainfo = new AutenticacaoInfo({
          nome: decoded['nome'],
          numeroInscricao: decoded['numeroInscricao'],
          numeroInscricaoTexto: decoded['numeroInscricaoTexto'],
          certificadoTipo: decoded['certificadoTipo'],
        }); 
      }
    });

    this.atualizarAgendamentos();
    this.atualizarAcompanhamentos();

    setInterval(() => {
      this.atualizarAgendamentos();
      this.atualizarAcompanhamentos();
    }, 25000);
  }

  public sair() {
    this.autenticacaoService.terminarSessao().subscribe();
  }

  atualizarAgendamentos() {
    this.dashService.contarAgendamentosHoje()
    .subscribe((indicador) => {
      this.agendamentosHoje = indicador.valor;
    })
  }

  atualizarAcompanhamentos() {
    this.dashService.contarAcompanhamentosAtivos()
    .subscribe((indicador) => {
      this.acompanhamentosAtivos = indicador.valor;
    })
  }

  abrirAcompanhamentos() {
    this.meusAcompanhamentos.abrir();
  }

  abrirAgendamentos() {
    this.meusAgendamentos.abrir();
  }
}
